const OtmDetalle = ({ otm }) => (
  <>
    <div className="timeline-body">
      <div className="row pb-2">
        {/* Actividades */}
        <div className="col-md">
          <div>
            <i className="fas fa-file-alt mr-2"></i>
            <strong>ACTIVIDADES EJECUTADAS</strong>
          </div>
          <ol className="pl-3">
            {otm.actividades?.map((actividad, idx) => (
              <li key={`${otm.otm}-act-${idx}`}>{actividad}</li>
            ))}
          </ol>
        </div>

        {/* Repuestos */}
        {Array.isArray(otm.repuestos) && otm.repuestos.length > 0 && (
          <div className="col-md border-left">
            <div>
              <i className="fas fa-cog mr-2"></i>
              <strong>REPUESTOS INSTALADOS</strong>
            </div>
            <table className="table table-sm table-striped small">
              <thead>
                <tr>
                  <th>SAP</th>
                  <th>Denominación</th>
                  <th>Detalle</th>
                  <th>Und.</th>
                  <th className="th-sm">Cant.</th>
                </tr>
              </thead>
              <tbody>
                {otm.repuestos.map((rep, idx) => (
                  <tr key={`${rep.codigo_sap}-${idx}`}>
                    <td>{rep.codigo_sap}</td>
                    <td>{rep.material}</td>
                    <td>{rep.descripcion}</td>
                    <td>{rep.unidad_medida}</td>
                    <td>{rep.cantidad}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Observaciones */}
      {otm.observacion && otm.observacion.trim() !== "" && (
        <div className="row">
          <div className="col bg-light">
            <div className="p-1">
              <div><strong>🔎OBSERVACIONES:</strong></div>
              <pre className="p-1 mb-0">{otm.observacion}</pre>
            </div>
          </div>
        </div>
      )}
    </div>

    {/* Footer */}
    <div className="timeline-footer bg-light">
      <div className="mr-1"><b>🔹EJECUTOR :</b> {otm.ejecutor}</div>
      {otm.personal?.map((p, idx) => (
        <div key={`${otm.otm}-pers-${idx}`} className="mr-1">
          <b>🔹PERSONAL :</b> {p}
        </div>
      ))}
    </div>
  </>
);

export default OtmDetalle;
